import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Text:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Password:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Number:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Number:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Email:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Search:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Textarea:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Has Button:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Has Error:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_base_input = _resolveComponent("vue-base-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _hoisted_1,
      _createVNode(_component_vue_base_input, {
        type: 'text',
        placeholder: "name",
        label: "your name",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_2,
      _createVNode(_component_vue_base_input, {
        type: 'password',
        placeholder: "password",
        label: "your password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        hasButton: true
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_3,
      _createVNode(_component_vue_base_input, {
        type: 'number',
        placeholder: "number",
        label: "your number",
        modelValue: _ctx.number,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.number) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_4,
      _createVNode(_component_vue_base_input, {
        type: 'tel',
        placeholder: "telephone",
        label: "your telephone",
        modelValue: _ctx.telephone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telephone) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_5,
      _createVNode(_component_vue_base_input, {
        type: 'email',
        placeholder: "info@email.com",
        label: "your email",
        modelValue: _ctx.email,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_6,
      _createVNode(_component_vue_base_input, {
        type: 'search',
        placeholder: "search...",
        hasButton: true,
        label: "search...",
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_7,
      _createVNode(_component_vue_base_input, {
        type: 'textarea',
        placeholder: "your message",
        label: "your message...",
        modelValue: _ctx.message,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.message) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_8,
      _createVNode(_component_vue_base_input, {
        type: 'text',
        placeholder: "nick name",
        label: "nick name",
        hasButton: true,
        buttonText: 'Send',
        modelValue: _ctx.nickName,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nickName) = $event)),
        onOnInputButtonClick: _ctx.onInputButtonClick
      }, null, 8, ["modelValue", "onOnInputButtonClick"])
    ]),
    _createElementVNode("section", null, [
      _hoisted_9,
      _createVNode(_component_vue_base_input, {
        type: 'email',
        placeholder: "info@email.com",
        label: "your email",
        buttonText: 'Send',
        modelValue: _ctx.emailError,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.emailError) = $event)),
        error: 'Email is not valid.'
      }, null, 8, ["modelValue", "error"])
    ])
  ], 64))
}